module.exports = __webpack_public_path__ + "static/img/about-image3.f565b00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-image3.jpg
// module id = 62
// module chunks = 20